import { useState } from "react";
import ReactSimplyCarousel from "react-simply-carousel";
import ScreenshotRepo from "../repository/ScreenshotRepo";

const ScreenshotList = () => {
  const [activeSlideIndex, setActiveSlideIndex] = useState(0);
  return (
    <div>
      <ReactSimplyCarousel
        activeSlideIndex={activeSlideIndex}
        onRequestChange={setActiveSlideIndex}
        itemsToShow={1}
        itemsToScroll={1}
        autoplay={true}
        autoplayDelay={3000}
        speed={600}
        forwardBtnProps={{
          style: {
            alignSelf: "center",
            background: "transparent",
            border: "none",
            borderRadius: "50%",
            color: "grey",
            cursor: "pointer",
            fontSize: "20px",
            height: 30,
            lineHeight: 1,
            textAlign: "center",
            width: 30,
          },
          children: <span className="right-arrow fw-bolder">{`>`}</span>,
        }}
        backwardBtnProps={{
          style: {
            alignSelf: "center",
            background: "transparent",
            border: "none",
            borderRadius: "50%",
            color: "grey",
            cursor: "pointer",
            fontSize: "20px",
            height: 30,
            lineHeight: 1,
            textAlign: "center",
            width: 30,
          },
          children: <span className="left-arrow fw-bolder">{`<`}</span>,
        }}
        responsiveProps={[
          {
            itemsToShow: 1,
            itemsToScroll: 1,
            minWidth: 768,
          },
        ]}
      >
        {ScreenshotRepo.carouselImages.map((data, index) => (
          <div style={{ width: 700 }} className="outerCarousel" key={index}>
            <img src={data.img} alt="Slider" className="carousel-image-slide" />
          </div>
        ))}
      </ReactSimplyCarousel>
    </div>
  );
};

export default ScreenshotList;
